(() => {
  const STORAGE_KEY = 'fusedOfficialLineDismissedUntil';
  const SESSION_KEY = 'fusedOfficialLineShown';
  const DISPLAY_DELAY = 5000;
  const DISMISS_DURATION = 30 * 24 * 60 * 60 * 1000;

  const readStorage = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const writeStorage = (storage, key, value) => {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // The popup still works when browser storage is unavailable.
    }
  };

  const initializePopup = (scope = document) => {
    scope.querySelectorAll('[data-official-line-popup]').forEach((popup) => {
      if (popup.dataset.initialized === 'true') return;
      popup.dataset.initialized = 'true';

      const closeButton = popup.querySelector('[data-official-line-close]');
      const lineLink = popup.querySelector('[data-official-line-link]');
      const panel = popup.querySelector('[role="dialog"]');
      const isDesignMode = Boolean(window.Shopify && Shopify.designMode);
      const hasLineUrl = popup.dataset.urlReady === 'true';

      if (!isDesignMode && !hasLineUrl) return;

      const dismissedUntil = Number(readStorage(window.localStorage, STORAGE_KEY) || 0);
      const shownThisSession = readStorage(window.sessionStorage, SESSION_KEY) === 'true';
      if (!isDesignMode && (dismissedUntil > Date.now() || shownThisSession)) return;

      let previouslyFocusedElement = null;

      const rememberDismissal = () => {
        writeStorage(window.localStorage, STORAGE_KEY, String(Date.now() + DISMISS_DURATION));
      };

      const hidePopup = (remember = true) => {
        if (remember && !isDesignMode) rememberDismissal();
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('official-line-popup-open');
        document.removeEventListener('keydown', handleKeydown);

        if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
          previouslyFocusedElement.focus();
        }
      };

      const handleKeydown = (event) => {
        if (event.key === 'Escape') hidePopup(true);
      };

      const showPopup = () => {
        previouslyFocusedElement = document.activeElement;
        writeStorage(window.sessionStorage, SESSION_KEY, 'true');
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('official-line-popup-open');
        document.addEventListener('keydown', handleKeydown);
        if (closeButton) closeButton.focus();
      };

      if (closeButton) closeButton.addEventListener('click', () => hidePopup(true));

      if (lineLink) {
        lineLink.addEventListener('click', (event) => {
          if (!hasLineUrl) {
            event.preventDefault();
            return;
          }
          if (!isDesignMode) rememberDismissal();
        });
      }

      window.setTimeout(showPopup, isDesignMode ? 250 : DISPLAY_DELAY);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializePopup());
  } else {
    initializePopup();
  }

  document.addEventListener('shopify:section:load', (event) => initializePopup(event.target));
})();
